var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-choice-selector"},[_c('ssr-carousel',_vm._b({},'ssr-carousel',_vm.config,false),_vm._l((_vm.products),function(product){return _c('gift-choice-option',{key:product.id,attrs:{"product":product}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }